import redirectsList from '/redirectsList.json';

import { getRouteUrl } from '@utils/urls';

import { LANGUAGES } from '@common/constants/languages';
import { PRE_LOGIN } from '@common/routes';

export const redirectToLoginWithTarget = (router, method = 'push') => {
  const query = { target: `/${router.locale}${router.asPath}` };

  router[method](
    {
      pathname: PRE_LOGIN,
      query,
    },
    {
      pathname: getRouteUrl(router.locale, PRE_LOGIN),
      query,
    },
  );
};

export const validateRedirectsByResolvedUrl = resolvedUrl => {
  const match = redirectsList.find(
    ({ source }) =>
      encodeURIComponent(source) === encodeURIComponent(resolvedUrl) ||
      encodeURIComponent(source).includes(encodeURIComponent(resolvedUrl)) ||
      new RegExp(source).test(resolvedUrl),
  );

  return match;
};

export const slugRouteRedirectsHandler = (
  slug = [],
  resourcePath = '',
  locale = '',
) => {
  const fullResourcePathArray = [locale, ...slug];
  const redirectSourcePath = `/${fullResourcePathArray.join('/')}`;
  const redirectDestinationPath = `/${locale}${resourcePath}`;

  const isSomeSlugPartLocale = LANGUAGES.some(availableLocale =>
    slug.includes(availableLocale),
  );

  if (isSomeSlugPartLocale) {
    const validatedRedirectsFromBaseResourcePath =
      validateRedirectsByResolvedUrl(resourcePath);

    if (validatedRedirectsFromBaseResourcePath) {
      return {
        redirect: validatedRedirectsFromBaseResourcePath,
      };
    }

    const validatedRedirectsFromRedirectSourcePath =
      validateRedirectsByResolvedUrl(redirectSourcePath);

    if (validatedRedirectsFromRedirectSourcePath) {
      return {
        redirect: validatedRedirectsFromRedirectSourcePath,
      };
    }

    return {
      redirect: {
        destination: redirectDestinationPath,
        permanent: true,
      },
    };
  }

  const validatedRedirectsFromBaseResourcePath =
    validateRedirectsByResolvedUrl(resourcePath);

  if (validatedRedirectsFromBaseResourcePath) {
    return {
      redirect: validatedRedirectsFromBaseResourcePath,
    };
  }

  const validatedRedirectsFromRedirectSourcePath =
    validateRedirectsByResolvedUrl(redirectSourcePath);

  if (validatedRedirectsFromRedirectSourcePath) {
    return {
      redirect: validatedRedirectsFromRedirectSourcePath,
    };
  }

  return {
    notFound: true,
  };
};
